import React, { useCallback } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "react-final-form";
import Validator from "../../../../_helpers/validate.schema";
import { UiCol } from "../../../_uiComponents/grid-container/GridContainer";
import { UiInput, UiInputLink } from "../../../_uiComponents/form/UiInput";
import { getFingerPrint } from "../../../../_helpers/support.services";
import { UiButton, UiButtonPrimary } from "../../../_uiComponents/form/UiButton";
import { loginAuthRequest } from "../../../../_redux/_actions";
import UiInlineSuccessMessage from "../../../_uiComponents/form/UiInlineSuccessMessage"
import UiMobileInput  from "../../../_uiComponents/form/UiMobileInput";

const validateSchema = () =>
    yup.object().shape({
        currentMobile: yup.string().required("Current mobile number is required."),
        newPhoneNumber: yup.string().required("New mobile number is required."),
    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};

export default function ChangeMobileNumber(props) {

    const submit = async (values) => {
        props.handleMobileUpdate(values)
    };

    return (
        <Form
            onSubmit={submit}
            validate={onValidate}
            render={({ handleSubmit, hasValidationErrors }) => (
                <form onSubmit={validateSchema}>
                    <UiInlineSuccessMessage />

                    <UiCol lg="12" className="sb-profile-mob-no">
                        <UiMobileInput 
                            placeholder="Current Mobile Number"
                            type="text"
                            name="currentMobile" />
                       
                    </UiCol>

                    <UiCol lg="12" className="sb-profile-mob-no">
                        <UiMobileInput 
                            placeholder="New Mobile Number"
                            type="text"
                            name="newPhoneNumber" />
                       
                    </UiCol>

                    <UiCol lg="12">
                        <div className="sb-prof-pwd-update-btn">
                            <UiButtonPrimary
                                btnName={"Verify"}
                                onClick={handleSubmit}
                            />
                        </div>
                    </UiCol>
                </form>
            )}
        />
    );
}
